import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { AccountService } from "@/services/AccountService"
import {
  emptyPaperBillState,
  IPaperBillState,
  PaperBillService,
} from "@/services/PaperBillService"

export const getPaperBillState = (accountNumber: string) => {
  const queries = new QueryAggregator()
  let paperBillState: IPaperBillState = emptyPaperBillState()

  const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)
  queries.add(coreIdQuery)

  if (coreIdQuery.data) {
    const stateQuery = PaperBillService.getState(coreIdQuery.data)
    queries.add(stateQuery)
    paperBillState = stateQuery.data
  }

  return queries.setData(paperBillState).getAggregate()
}
